<template>
    <div class="content">
        <div class="CaseBaseTitle">{{gpsState.city}}大气污染过程案例库</div>
        <div class="CaseBaseNav">
            <div class="navItem">
                <el-date-picker
                        v-model="year"
                        type="year"
                        @change="yearChange"
                        placeholder="选择年" size="mini" value-format="yyyy">
                </el-date-picker>
            </div>
            <div class="navItem 细粒子污染">
                细粒子污染过程 {{caseData.细粒子污染 || 0}} 天
            </div>
            <div class="navItem 臭氧污染">
                臭氧污染过程{{caseData.臭氧污染 || 0}}天
            </div>
            <div class="navItem 沙尘污染">
                沙尘污染过程{{caseData.沙尘污染 || 0}}天
            </div>
            <div class="navItem NO2">
                NO2污染过程{{caseData.NO2 || 0}}天
            </div>
        </div>
        <div class="showType">
            <div :class="{active:index===showTypeIndex}" @click="showTypeIndex=index"
                 v-for="(item,index) in showTypeList" :key="index">
                {{item.name}}
            </div>
        </div>
        <div class="date_wrapper_class" v-show="showTypeIndex===0">
            <YearCalendar
                    v-model="year"
                    :activeDates.sync="activeDates"
                    @toggleDate="toggleDate"
                    prefixClass="date_wrapper_class_name"
                    :activeClass="activeClass"
                    lang="tw"
                    :showYearSelector="false"
            ></YearCalendar>
        </div>
        <div class="date_wrapper_class" v-show="showTypeIndex===1">
            <a-table
                    v-if="caseList"
                    :columns="caseColumns"
                    :dataSource="caseList"
                    rowKey="id"
                    :rowClassName="rowClassName"
                    :pagination="false"
            >
                <div slot="startTime" slot-scope="startTime" class="type">
                    {{startTime  | YearDate}}
                </div>
                <div slot="endTime" slot-scope="endTime" class="type">
                    {{endTime | YearDate}}
                </div>
                <div slot="operation" slot-scope="operation,dataItem" class="type">
                    <a @click="jump(dataItem)">浏览</a>
                </div>
            </a-table>

            <a-empty v-else/>
        </div>
    </div>
</template>

<script>
    import YearCalendar from '../../components/YearCalendar/index'
    import apiUrl from "../../utils/UrlApi"


    function YearDate(str) {
        if (str) {
            var d = new Date(str)
            var year = d.getFullYear()
            var month = d.getMonth() + 1
            var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
            // var hour = d.getHours() < 10 ? '0' + d.getHours() : '' + d.getHours()
            // var minutes = d.getMinutes() < 10 ? '0' + d.getMinutes() : '' + d.getMinutes()
            // var seconds = d.getSeconds() < 10 ? '0' + d.getSeconds() : '' + d.getSeconds()
            // return hour + ':' + minutes + ':' + seconds
            return year + '-' + month + '-' + day
        } else {
            return ''
        }
    }


    export default {
        name: "index",
        components: {YearCalendar},
        computed:{
            gpsState: {
                get() {
                    return this.$store.state.gpsState;
                },
                set(val) {
                    this.$store.commit('updateGpsState', val);
                }
            }
        },
        data() {
            return {
                year: '2021',
                activeDates: [],
                activeClass: '',
                caseData: {},
                showTypeList: [
                    {name: '日历'},
                    {name: '列表'},
                ],
                showTypeIndex: 0,
                caseList: [],
                caseColumns: [
                    {
                        title: '开始时间', dataIndex: 'startTime', width: '12.5%', align: 'center',
                        scopedSlots: {customRender: 'startTime'}
                    },
                    {
                        title: '结束时间', dataIndex: 'endTime', width: '12.5%', align: 'center',
                        scopedSlots: {customRender: 'endTime'}
                    },
                    {title: '持续时间(天)', dataIndex: 'day', width: '12.5%', align: 'center',},
                    {title: '污染类型', dataIndex: 'type', width: '12.5%', align: 'center',},
                    {title: '案例名称', dataIndex: 'name', width: '12.5%', align: 'center',},
                    {title: '首污', dataIndex: 'pollutionTime', width: '12.5%', align: 'center',},
                    {title: '污染等级', dataIndex: 'pollutionLevel', width: '12.5%', align: 'center',},
                    {
                        title: '操作', dataIndex: 'operation', key: 'operation', width: '12.5%', align: 'center',
                        scopedSlots: {customRender: 'operation'}
                    }
                ],
            }
        },
        mounted() {
            this.getData()
            this.getDataList()
        },
        methods: {
            yearChange(val){
                if(val){
                    this.getData()
                    this.getDataList()
                }

            },
            getData() {
                let params = {
                    year: this.year
                }
                this.$http.get(apiUrl.calendarList, {
                    params: params
                }).then(res => {

                    if(res.data.code!=='200'){
                        this.$message.error(res.data.message)
                        return
                    }

                    this.caseData = res.data.data
                    let list = []
                    // console.log(res)
                    res.data.data.list.forEach(req => {
                        list.push({
                            date: req.time,
                            className: req.type + ' bj' + req.shape,
                            id: req.id
                        })
                    })

                    this.activeDates = list

                    // console.log(res)
                })
            },
            getDataList() {
                let params = {
                    year: this.year
                }
                this.$http.get(apiUrl.calendar, {
                    params: params
                }).then(res => {
                    if(res.data.code!=='200'){
                        this.$message.error(res.data.message)
                        return
                    }
                    // console.log(res)
                    this.caseList = res.data.data
                })
            },
            toggleDate(dateInfo) {
                console.log(dateInfo)  // { date: '2010-10-23', selected: true }

                this.$router.push({
                    name: 'CaseBaseDetails',
                    query: {date: dateInfo.date}
                })
            },
            jump(item) {
                console.log(item)  // { date: '2010-10-23', selected: true }

                let date =   YearDate(item.startTime)

                this.$router.push({
                    name: 'CaseBaseDetails',
                    query: {date: date}
                })
            },
            rowClassName(record, index) {
                let className = 'dark';
                if (index % 2 === 1) className = 'light';
                return className;
            },
        }
    }
</script>


<style scoped lang="less">
    .content {
        padding-top: 20px;
        height: 100%;

        .CaseBaseTitle {
            text-align: center;
            font-size: 28px;
            padding: 10px 0;
        }

        .CaseBaseNav {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 20px 0;

            .navItem {
                padding: 0 10px;
                padding-left: 18px;
                margin-left: 8px;
                position: relative;
            }

            .navItem:after {
                content: '';
                position: absolute;
                width: 10px;
                height: 10px;
                left: 0;
                top: 50%;
                margin-top: -5px;
                border-radius: 50%;
            }

            .细粒子污染:after {
                background: black;
            }

            .臭氧污染:after {
                background: red;
            }

            .沙尘污染:after {
                background: orange;
            }
            .NO2:after {
                background: yellow;
            }
        }

        .date_wrapper_class {
        }
    }


    .showType {
        display: flex;
        margin: 10px 20px;
        justify-content: flex-start;

        div {
            padding: 4px 20px;
            cursor: pointer;
        }

        .active {
            background: #2ca9dc;
            color: #fff;
        }
    }

    /deep/ .ant-table .light {
        background-color: white;
    }

    /deep/ .ant-table .dark {
        background-color: rgb(240, 240, 241);
    }

    /deep/ .ant-table-thead > tr > th {
        padding: 16px 0 !important;
    }

    /deep/ .ant-table-tbody > tr > td {
        padding: 16px 0 !important;
    }

</style>

<style lang="less">
    .date_wrapper_class {
        .SO2 {
            background-color: red;
            color: white
        }

        .NO2 {
            background-color: blue;
            color: white
        }

        .O3 {
            background-color: green;
            color: white
        }

        .CO {
            background-color: purple;
            color: white
        }

        .PM10 {
            background-color: yellow;
            color: black;
        }

        .PM25 {
            background-color: black;
            color: white;
        }

        .细粒子污染 {
            background-color: black;
            color: white;
        }

        .臭氧污染 {
            background-color: red;
            color: white
        }

        .沙尘污染 {
            background-color: orange;
            color: black;
        }

        .NO2 {
            background-color: yellow;
            color: black;
        }
        .bj1 {
            border-radius: 50%;
            margin: 2px;
        }

        .bj2 {
        }
    }
</style>